<template>
    <div class="Interactions">
        <h2>Activity <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /> <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddInteraction()" class="olive-green-text pointer" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Start Date:</label>
                        <flat-pickr v-model="Filters.StartDate" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>End Date:</label>
                        <flat-pickr v-model="Filters.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Category:</label>
                        <select class="form-control" v-model="Filters.Category">
                            <option value="All">All</option>
                            <option v-for="InteractionCategory in InteractionCategories" :value="InteractionCategory.value">{{ InteractionCategory.text }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
        <vuetable :fields="ActivityTableOptions.Fields"
                  pagination-path=""
                  :api-mode="false"
                  class="vue-datatable"
                  :data-manager="DataManager"
                  ref="datatable">

            <template slot="ActivityActions" scope="props">
                <div class="ActivityActions">
                    <span class="horizontal-icons-padded"><font-awesome-icon :icon="['fa', 'edit']" @click="ShowEditInteraction(props.rowData.ChartActivity)" class="pointer" /></span>
                    <span class="horizontal-icons-padded">
                        <DeleteIcon :requires-confirmation="true"
                                    confirmation-string="Really delete this Interaction?"
                                    endpoint="ChurchEngagement/ChartActivity/DeleteActivity"
                                    :payload="{Id: props.rowData.ChartActivity.Id}"
                                    :perform-global-update="false" 
                                    @success="DeleteSuccess"/>
                    </span>
</div>
            </template>
        </vuetable>

        <!--ADD/Edit INTERACTION MODAL-->
        <b-modal ref="add-interaction-modal" :title="AddEditModalTitle" hide-footer>
            <b-container fluid>
                <b-form @submit="AddOrUpdateInteraction">
                    <b-row>
                        <div class="form-group">
                            <label>Date:</label>
                            <flat-pickr v-model="TargetInteraction.EffectiveDateTime" class="form-control" :config="DateConfig" required></flat-pickr>
                        </div>
                        <div class="form-group">
                            <label>Category:</label>
                            <select v-model="TargetInteraction.Category" required class="form-control">
                                <option v-for="InteractionCategory in InteractionCategories" :value="InteractionCategory.value">{{ InteractionCategory.text }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Activity:</label>
                            <textarea rows="6" v-model="TargetInteraction.Narrative" required class="form-control"></textarea>
                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAddEdit()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>

    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import DeleteIcon from '../../../Core/ItemEditors/DeleteIcon.vue';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faTimes } from '@fortawesome/free-solid-svg-icons';
    library.add(faTimes);

    import { EventBus } from '../../../../services/event-bus.js';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        created() {
            let vm = this;
            EventBus.$on('chart-activity-updated', val => {
                if (val == vm.ChurchRecordData.Church.Id) {
                    vm.GetActivities();
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('chart-activity-updated');
        },
        props: [
            "ChurchRecordData"
        ],
        data: function () {
            return {
                Interactions: [],
                AddEditModalTitle: "",
                TargetInteraction: {
                    Category: "",
                    Narrative: "",
                    EffectiveDateTime: "",
                    ChartID: this.ChurchRecordData.Church.Id,
                    ActivityID: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altFormat: 'm/d/Y',
                    altInput: true, 
                },
                TableSearch: "",
                Filters: {
                    StartDate: moment().add(-2, 'months').format('YYYY-MM-DD'),
                    EndDate: "",
                    Category: "All"
                },
                ActivityTableOptions: {
                    Fields: [
                        {
                            name: 'ChartActivity.EffectiveDateTime',
                            title: "Date/Time",
                            callback: 'formatDateOptionalTime|MM/DD/YY',
                            sortField: 'ChartActivity.EffectiveDateTime'
                        },
                        {
                            name: 'ChartActivity.Category',
                            title: 'Category',
                            sortField: 'ChartActivity.Category'
                        },
                        {
                            name: 'ChartActivity.Narrative',
                            title: "Activity",
                            sortField: 'ChartActivity.Narrative'
                        },
                        {
                            name: 'ChartActivity.AuthorUser.UserName',
                            title: 'Assignee',
                            sortField: 'ChartActivity.AuthorUser.UserName'
                        },
                        {
                            name: '__slot:ActivityActions',
                            title: "Actions",
                        }
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetActivities();
            },
            DeleteSuccess() {
                EventBus.$emit('chart-activity-updated', this.ChurchRecordData.Church.Id);
            },
            GetActivities() {
                this.$MasterAPI.ExecuteRequest("GET", "ChurchEngagement/ChartActivity/GetInteractions",
                    {
                        StartDate: vm.Filters.StartDate,
                        EndDate: vm.Filters.EndDate,
                        Category: vm.Filters.Category,
                        ChurchID: vm.ChurchRecordData.Church.Id
                    }, this.GetActivitiesSuccess, () => { }, false);
            },
            GetActivitiesSuccess(response) {
                this.Interactions = response.data.data;
                this.$refs.datatable.refresh();
            },
            ResetTargetActivity() {
                this.TargetInteraction.Category = "";
                this.TargetInteraction.Narrative = "";
                this.TargetInteraction.EffectiveDateTime = "";
                this.TargetInteraction.ActivityID = "";
            },
            ShowEditInteraction(activity) {
                this.ResetTargetActivity();
                this.AddEditModalTitle = "Edit Activity";

                this.TargetInteraction.Category = activity.Category;
                this.TargetInteraction.Narrative = activity.Narrative;
                this.TargetInteraction.EffectiveDateTime = activity.EffectiveDateTime;
                this.TargetInteraction.ActivityID = activity.Id;

                this.$refs["add-interaction-modal"].show();
            },
            ShowAddInteraction() {
                this.ResetTargetActivity();
                this.AddEditModalTitle = "Add New Activity";
                this.$refs["add-interaction-modal"].show();
            },
            AddOrUpdateInteraction(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "ChurchEngagement/ChartActivity/AddOrUpdateInteraction", this.TargetInteraction, this.AddOrUpdateInteractionSuccess, () => { }, true);
            },
            AddOrUpdateInteractionSuccess(response) {
                //this.GetActivities();
                EventBus.$emit('chart-activity-updated', this.ChurchRecordData.Church.Id);
                this.$refs["add-interaction-modal"].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatDateOptionalTime(value, dflt ) {
                if (value == null) {
                    return dflt;
                }
                let initialValue = moment(value, 'YYYY-MM-DD HH:mm:ss');
                if (initialValue.hours() == 0 && initialValue.minutes() == 0) {
                    return initialValue.format('MM/DD/YYYY');
                } else {
                    return initialValue.format('MM/DD/YYYY h:mm A');
                }
            },
            CancelAddEdit() {
                this.$refs["add-interaction-modal"].hide();
            },
            
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.Interactions;
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            }
            //SearchResult(input) {
            //    var tableInfo = Array.prototype.map.call(document.querySelectorAll('#childrendatatableid tbody tr'), function(tr){
            //            return Array.prototype.map.call(tr.querySelectorAll('td'), function(td){
            //                return td.innerHTML;
            //        });
            //    });
            //    console.log(tableInfo);
            //}
        },
        components: {
            Vuetable,
            DeleteIcon,
            flatPickr
        },
        computed: {
            InteractionCategories: function () {
                return this.$store.state.Options.ChurchEngagement.CEActivityOptions;
            }
        },
        mounted() {
            this.GetActivities();
        }
    }
</script>

<style scoped>
    .vue-datatable {
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
</style>